import agent from './agent';
import areas from './areas';
import attributes from './attributes';
import auth from './auth';
import automations from './automations';
import billReports from './billReports';
import cardBlacklist from './card-blacklist';
import caregivers from './caregivers';
import createScenario from './createScenario';
import createSite from './createSite';
import customRules from './customRules';
import driverReport from './driverReport';
import drivers from './drivers';
import driverShifts from './driverShifts';
import driversOnline from './driversOnline';
import employees from './employees';
import extraServices from './extraServices';
import fares from './fares';
import filters from './filters';
import forgotPassword from './forgotPassword';
import holidays from './holidays';
import importSection from './import';
import integrations from './integrations';
import invitations from './invitations';
import jobs from './jobs';
import jobsCalendar from './jobsCalendar';
import layout from './layout';
import liveMap from './liveMap';
import locationFacilityTypes from './locationFacilityTypes';
import locations from './locations';
import missionControl from './missionControl';
import onboarding from './onboarding';
import parents from './parents';
import passengers from './passengers';
import performanceDashboard from './performanceDashboard';
import permissions from './permissions';
import profiles from './profiles';
import rates from './rates';
import reports from './reports';
import resetPassword from './resetPassword';
import roiSimulation from './roiSimulation';
import services from './services';
import settings from './settings';
import shifts from './shifts';
import shuttleReports from './shuttleReports';
import shuttles from './shuttles';
import signup from './signup';
import students from './students';
import suppliers from './suppliers';
import support from './support';
import systemSettings from './systemSettings';
import timeline from './timeline';
import tripReports from './tripReports';
import trips from './trips';
import uniqueDriversReport from './uniqueDriversReport';
import units from './units';
import userProfile from './userProfile';
import users from './users';
import vehicleReport from './vehicleReport';
import vehicles from './vehicles';

const index = {
  attributes,
  driverReport,
  roiSimulation,
  suppliers,
  vehicleReport,
  permissions,
  passengers,
  drivers,
  jobs,
  users,
  userProfile,
  invitations,
  signup,
  areas,
  importSection,
  services,
  driversOnline,
  units,
  trips,
  vehicles,
  driverShifts,
  settings,
  shuttles,
  profiles,
  fares,
  rates,
  agent,
  locations,
  extraServices,
  reports,
  shifts,
  support,
  systemSettings,
  layout,
  shuttleReports,
  forgotPassword,
  resetPassword,
  timeline,
  auth,
  tripReports,
  uniqueDriversReport,
  missionControl,
  onboarding,
  createSite,
  createScenario,
  holidays,
  cardBlacklist,
  filters,
  integrations,
  automations,
  parents,
  students,
  employees,
  jobsCalendar,
  caregivers,
  customRules,
  liveMap,
  billReports,
  performanceDashboard,
  locationFacilityTypes,
};

export default index;
